// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ts5CTOCvrnJ9ET {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-150, 0.75rem);
  bottom: var(--ds-space-150, 0.75rem);
  left: var(--ds-space-150, 0.75rem);
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
}
@media print {
  .ts5CTOCvrnJ9ET {
    position: relative;
    right: auto;
    left: auto;
  }
}
`, ""]);
// Exports
export var container = `ts5CTOCvrnJ9ET`;
export default ___CSS_LOADER_EXPORT___;
